import React, { useState } from "react";
import { X } from "lucide-react";
import FileTreePanel from "./FileTreePanel";

export default function FileTreePicker({
  open,
  onClose,
  onConfirm,
  selectionMode = "single",
  initialCheckedFileIds = [],
}) {
  const [picked, setPicked] = useState([]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose} // 바깥 클릭 시 닫기
      />

      {/* Dialog */}
      <div className="relative z-10 w-full max-w-[720px] sm:max-w-[900px] rounded-t-3xl sm:rounded-2xl bg-white border border-slate-200 shadow-[0_18px_40px_rgba(15,23,42,0.18)]">
        <div className="flex items-center justify-between px-5 py-3 border-b bg-slate-50/60">
          <h3 className="text-[15px] font-semibold text-slate-900">
            자료실에서 선택
          </h3>
          <button
            onClick={onClose}
            className="p-1.5 rounded-full hover:bg-slate-100"
          >
            <X className="w-5 h-5 text-slate-500" />
          </button>
        </div>

        <div className="p-5">
          <FileTreePanel
            selectionMode={selectionMode}
            initialCheckedFileIds={initialCheckedFileIds}
            onPick={
              selectionMode === "single"
                ? (file) => {
                  onConfirm?.([file]);
                  onClose?.();
                }
                : undefined
            }
            onChangeSelected={setPicked}
          />
        </div>

        {selectionMode === "multiple" && (
          <div className="px-5 py-4 border-t flex items-center justify-between bg-slate-50 rounded-b-3xl sm:rounded-b-2xl">
            <div className="text-[13px] text-slate-600">
              선택됨: <b>{picked.length}</b>개
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={onClose}
                className="rounded-full border border-slate-300 px-4 py-2.5 text-[13px] text-slate-700 hover:bg-slate-100"
              >
                취소
              </button>
              <button
                onClick={() => {
                  onConfirm?.(picked);
                  onClose?.();
                }}
                className="rounded-full bg-indigo-600 px-4 py-2.5 text-[13px] font-medium text-white shadow hover:bg-indigo-700 disabled:opacity-40"
                disabled={!picked.length}
              >
                선택 {picked.length}개
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
